import React, { Component } from 'react'
import { getInfoDetail} from '../api'
import { message,Icon } from 'antd'
import moment from 'moment';

class InfoDetail extends Component {
    constructor () {
        super()
        this.state = {
            articleInfo: {
                titel: '',
                date: '',
                content: '',
                attachment: {},
                url:'',
                name:''
            }
        }
    }

    componentDidMount () {
        let id = this.props.match.params.id
        // 获取信息披露详情
        getInfoDetail({ id }).then(res => {
            if (res.data) {
                const { title, content } = res.data[0];
                const { url=null, name=null } = res.attachment.length>0?res.attachment[0]: {};
                const date = res.data[0].publishtime;
                this.setState({
                    articleInfo: {
                        title, date, content,url,name
                    }
                })
            }
        }).catch(err => {
            message.error(err.msg)
        })
    }

    render () {
        const { title, date, content,url,name } = this.state.articleInfo
        return (
            <div>
                <div className="article">
                    <div className="article-title">
                        <h3>{ title }</h3>
                    </div>
                    <div className="publish-date">
                        日期：<span>{moment(date).format('YYYY-MM-DD')}</span>
                    </div>
                    <div className="article-content">
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>    
                    </div>  
                    {
                        url &&
                        <div className="article-attachment">
                        附件：<a href={url} target='_blank' rel='noopener noreferrer' download={name}>{name}&nbsp;&nbsp;&nbsp;&nbsp;<Icon type="download" /></a>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default InfoDetail